/* Sample box: shared selection store.

   Persisted, unlike the compare feature: the whole point is that a scent added
   on one oil page is still there three pages later. Stale handles are filtered
   against the live list when the drawer opens, so a discontinued scent drops
   out silently instead of reaching the cart. */
window.croBox = (function () {
  var KEY = 'aroma:samplebox';
  var MAX = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(l) {
    try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, MAX))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('box:changed', { detail: read() }));
  }
  function has(h) { return read().indexOf(h) > -1; }
  function add(h) {
    var l = read();
    if (l.indexOf(h) > -1) return 'dupe';
    if (l.length >= MAX) return 'full';
    l.push(h); write(l); return 'ok';
  }
  function remove(h) {
    var l = read(), i = l.indexOf(h);
    if (i > -1) { l.splice(i, 1); write(l); }
  }
  function keepOnly(valid) {
    var l = read().filter(function (h) { return valid.indexOf(h) > -1; });
    if (l.length !== read().length) write(l);
  }
  return {
    read: read, has: has, add: add, remove: remove, clear: function () { write([]); },
    keepOnly: keepOnly, max: MAX
  };
})();
